import { DestroyRef } from '@angular/core';
import { TypedEventEmitter } from '../shared/typed-event-emitter';

// Interface for objects using the addEventListener/removeEventListener API
interface LegacyEventSource {
  addEventListener: Function;
  removeEventListener: Function;
}

/**
 * Subscribes to multiple EventDispatcher events and invokes a callback for each.
 * All listeners are automatically removed on destroy.
 *
 * @param source - Any object with addEventListener/removeEventListener or a TypedEventEmitter
 * @param events - Map of event type to handler
 * @param destroyRef - Angular DestroyRef for automatic cleanup
 */
export function onViewerEvents(
  source: TypedEventEmitter<any> | LegacyEventSource,
  events: Record<string, (event: any) => void>,
  destroyRef: DestroyRef,
): void {
  const entries = Object.entries(events);

  if (source instanceof TypedEventEmitter) {
    const unsubs: (() => void)[] = [];
    for (const [type, handler] of entries) {
      unsubs.push(source.subscribe(type, handler));
    }
    destroyRef.onDestroy(() => {
      for (const unsub of unsubs) {
        unsub();
      }
    });
  } else {
    for (const [type, handler] of entries) {
      source.addEventListener(type, handler);
    }
    destroyRef.onDestroy(() => {
      for (const [type, handler] of entries) {
        source.removeEventListener(type, handler);
      }
    });
  }
}
